export default __webpack_public_path__ + "static/media/50y.7877fbf5.png";